import React, { Component } from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import _ from "i18n";

import { fetchAvailableSlide, fetchSupportedIndicatorVars } from "Thunks";
import {
  setCurrentNavPage,
  setSlideListPaginationPage,
  setSlideListFilterStatus,
  setSlideListFilterisPublic,
  setSlideListFilterTitle,
  setSlideListFilterNewSlideIds,
  setSlidesListFilter
} from "actions";
import { selectCurrentOrganization } from "Selectors";
import { isFiduciaryAccess } from "Utils";

import { ICONS, SvgIcon } from "../Common/Icons";
import PageHeader from "../Common/PageHeader/PageHeader";
import TTPPaginator from "../Common/TTPPaginator";
import SlideFilter from "./SlideFilter";
import SlideList from "./SlideList";
import NotFoundV2 from "../NotFound/NotFoundV2";
import SlideListFetching from "./SlideListFetching";
import { NotificationBar } from "../Common/Notification/NotificationBar";
import NotificationApi from "../../services/NotificationServices";
import { getLabelsByLng, inIframe } from "../../utils";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
class SlideListPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedStates: ["ALL"],
      filterValue: "",
      notifications: "",
      loading: false,
      closeNotification: false,
      loadingNotificationCrossSharing: false,
      notificationsCrossSharing: "",
      closeNotificationCrossSharing: false,
      isFilterNewSlideActivated: false,
      slidesStatus: []
    };
  }
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(setCurrentNavPage("SLIDE_LIST"));
    dispatch(fetchSupportedIndicatorVars());
    dispatch(setSlideListFilterStatus([]));
    dispatch(setSlideListFilterisPublic("", ""));
    dispatch(setSlideListFilterTitle(""));
    dispatch(setSlidesListFilter(""));
    dispatch(setSlideListFilterNewSlideIds([]));
    this.handleGetNotificationSlide();
    this.handleGetNotificationSlideCrossSharing();
  }
  handleGetNotificationSlide() {
    this.setState({ loading: true });
    const { currentOrganization, user } = this.props;
    NotificationApi.getNotificationSlide(user.id, currentOrganization.uen).then(
      response => {
        this.setState({
          notifications: response.data.data,
          loading: false
        });
      }
    );
  }
  handleGetNotificationSlideCrossSharing() {
    this.setState({ loading: true });
    const { currentOrganization, user } = this.props;
    NotificationApi.getNotificationSlideCrossSharing(
      user.id,
      currentOrganization.uen
    ).then(response => {
      this.setState({
        notificationsCrossSharing: response.data.data,
        loadingNotificationCrossSharing: false
      });
    });
  }

  handleCloseNotification = () => {
    const { dispatch, currentOrganization, user } = this.props;
    NotificationApi.closeNotification(
      user.id,
      currentOrganization.uen,
      "SLIDE"
    ).then(response => {
      this.setState({
        closeNotification: true
      });
      if (this.state.isFilterNewSlideActivated) {
        dispatch(setSlideListFilterNewSlideIds([]));
      }
    });
  };
  handleNewSlideList = () => {
    const { dispatch } = this.props;
    this.setState({
      isFilterNewSlideActivated: true
    });
    dispatch(setSlideListFilterNewSlideIds(this.state.notifications.slideIds));
  };
  handleSharedSlideList = () => {
    const { dispatch } = this.props;
    this.setState({
      isFilterNewDashboardActivated: true
    });
    dispatch(
      setSlideListFilterNewSlideIds(
        this.state.notificationsCrossSharing.slideIds
      )
    );
  };
  handleCloseNotificationCrossSharing = () => {
    const { dispatch, currentOrganization, user } = this.props;
    NotificationApi.closeNotification(
      user.id,
      currentOrganization.uen,
      "SLIDE_SHARED"
    ).then(response => {
      this.setState({
        closeNotificationCrossSharing: true
      });
      if (this.state.isFilterNewSlideActivated) {
        dispatch(setSlideListFilterNewSlideIds([]));
      }
    });
  };
  componentDidUpdate(prevProps, prevState) {
    const { filter, paginationPage, pageSize } = prevProps;
    if (
      filter !== this.props.filter ||
      paginationPage !== this.props.paginationPage ||
      pageSize !== this.props.pageSize
    ) {
      this.props.dispatch(fetchAvailableSlide());
    }
  }
  handleSlideListPageChange = ({ selected }) => {
    this.props.dispatch(setSlideListPaginationPage(selected + 1));
  };
  renderPaginate() {
    let { slides, paginationPage, pageSize } = this.props;
    if (slides.error != null && slides.error.code === 404) {
      return "";
    }
    return (
      <TTPPaginator
        onPageChange={this.handleSlideListPageChange}
        pageSize={pageSize}
        nbResult={slides.nbResult}
        paginationPage={paginationPage}
      />
    );
  }
  handleFilterFormIsVisible = isVisible => {
    this.setState({ filterFormIsVisible: isVisible });
  };
  handleRedirectCreateSlide = () => {
    this.props.dispatch(push("/composition/slide"));
  };
  handleStateFilterChange = value => {
    this.setState({ selectedStates: value });
  };
  handleChangeFilterValue = value => {
    this.setState({ filterValue: value });
  };
  handleChangeSlidesStatus = value => {
    this.setState({ slidesStatus: value });
  };

  onTabChange = value => {
    let { dispatch } = this.props;
    this.setState({ selectedStates: [value] });
    dispatch(setSlideListFilterNewSlideIds([]));
    dispatch(setSlidesListFilter(""));
    dispatch(setSlideListFilterisPublic("", ""));
    if (value === "SHARED") {
      dispatch(setSlideListFilterisPublic("false", "neq"));
    }
    if (
      value === "LIBRARY" ||
      value === "MyTemplates" ||
      value === "Templates"
    ) {
      dispatch(setSlidesListFilter(value));
    }
    this.setState({ filterValue: value });
    dispatch(
      setSlideListFilterStatus(
        value === "CREATED" || value === "STANDARD" ? [value] : []
      )
    );
  };

  render() {
    let {
      slides,
      auth,
      currentOrganization,
      slidesItems,
      preferences,
      saved,
      fetched,
      fetching,
      saving,
      backOffice,
      lng,
      withoutHeader
    } = this.props;
    let {
      selectedStates,
      filterValue,
      notifications,
      loading,
      closeNotification,
      closeNotificationCrossSharing,
      loadingNotificationCrossSharing,
      notificationsCrossSharing,
      slidesStatus
    } = this.state;
    const { loggedAs, spaceAs } = auth;

    let filterFormIsVisible = false;
    let allowManager = loggedAs === "MANAGER" && spaceAs === "MANAGER";
    let allowCreateSlide = preferences && preferences.allowCreateSlide === "1";
    let allowUpdateSlide = preferences && preferences.allowUpdateSlide === "1";
    return (
      <div
        className="page-content"
        style={{
          padding: auth.withoutHeader ? "0px 0px 4.3rem 30px" : "0 0 4.3rem 0"
        }}
      >
        {inIframe() === false && (
          <div style={{ marginBottom: "10px" }}>
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}

        {!backOffice &&
          !closeNotification &&
          notifications &&
          !loading &&
          notifications.notifications.length > 0 && (
            <div
              style={{
                marginBottom: "10px",
                marginLeft: withoutHeader ? "-30px" : ""
              }}
            >
              <NotificationBar
                message={
                  notifications.count.includes(1)
                    ? _("notifyNewSlide") +
                      "'" +
                      getLabelsByLng(
                        notifications.notifications[0].slide,
                        lng
                      ) +
                      "'" +
                      _("notifyAtYourDisposal")
                    : notifications.count[0] + _("notifyNewSlides")
                }
                theme="greenTeal"
                onSeeMore={this.handleNewSlideList}
                onClose={this.handleCloseNotification}
              />
            </div>
          )}
        <div style={{ marginLeft: withoutHeader ? "-30px" : "" }}>
          {!backOffice &&
            !closeNotificationCrossSharing &&
            notificationsCrossSharing &&
            !loadingNotificationCrossSharing &&
            notificationsCrossSharing.notifications.length > 0 && (
              <NotificationBar
                message={
                  notificationsCrossSharing.count.includes(1)
                    ? _("notifyNewSharedSlide") +
                      "'" +
                      getLabelsByLng(
                        notificationsCrossSharing.notifications[0].slide,
                        lng
                      ) +
                      "'" +
                      _("notifyAtYourDisposal")
                    : notificationsCrossSharing.count[0] +
                      _("notifyNewSharedSlides")
                }
                theme="greenTeal"
                onSeeMore={this.handleSharedSlideList}
                onClose={this.handleCloseNotificationCrossSharing}
              />
            )}
        </div>
        <PageHeader
          header="slidesList"
          subHeader="slidesListSubHeader"
          icon={ICONS.MODELE_SLIDE}
        >
          {((isFiduciaryAccess(currentOrganization) &&
            allowCreateSlide &&
            allowManager) ||
            backOffice) && (
            <button
              className="btn secondary text-uppercase"
              onClick={() => this.handleRedirectCreateSlide()}
            >
              <SvgIcon icon={ICONS.SIMPLE_PLUS_ICON} className={""} />
              {_("createSlideTemplate")}
            </button>
          )}
        </PageHeader>
        {/*{this.props.suggestions && (*/}
        <SlideFilter
          filterFormIsVisible={this.handleFilterFormIsVisible}
          selectedStates={selectedStates}
          onStateFilterChange={this.handleStateFilterChange}
          onFilterValueChange={this.handleChangeFilterValue}
          handleChangeSlidesStatus={this.handleChangeSlidesStatus}
          onTabChange={this.onTabChange}
        />
        <div
          className="row align-center medium-11"
          style={{ marginTop: "-7px" }}
        >
          <div className={`medium-12`}>
            <TTPFilterHorizontalBar
              onTabChange={this.onTabChange}
              tabs={backOffice ? [] : slidesStatus}
              selectedTab={selectedStates}
              cssClass="medium-12"
              HideButton={true}
            />
          </div>
        </div>
        {fetching && <SlideListFetching withoutHeader={auth.withoutHeader} />}
        {saved || (fetched && slidesItems.length) ? (
          <div
            className={`row medium-11 ${filterFormIsVisible &&
              "add-margin-left"}`}
          >
            <SlideList
              slides={slidesItems}
              allowUpdateSlide={allowUpdateSlide}
              filterValue={filterValue}
              newTag={notifications}
              closeNewTag={closeNotification}
            />
          </div>
        ) : (
          <div
            className={`row align-center medium-11 ${filterFormIsVisible &&
              "add-margin-left"}`}
          >
            {!fetching ? <NotFoundV2 /> : ""}
          </div>
        )}

        <div
          className={`row align-center margin-bottom-2 ${filterFormIsVisible &&
            "add-margin-left"}`}
        >
          <div
            className={
              filterFormIsVisible ? "column medium-12" : "column medium-11"
            }
          >
            {slides.fetched && slides.items.length ? (
              this.renderPaginate()
            ) : (
              <div className="row pagination" />
            )}
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  auth: state.auth,
  currentOrganization: selectCurrentOrganization(state),
  slides: state.slideList,
  paginationPage: state.slideList.paginationPage,
  pageSize: state.slideList.pageSize,
  filter: state.slideList.filter,
  preferences: state.auth.preferences,
  suggestions: state.indicators.suggestions.items,
  slidesItems: state.slideList.items,
  fetching: state.slideList.fetching,
  fetched: state.slideList.fetched,
  saving: state.slideList.saving,
  saved: state.slideList.saved,
  backOffice: state.params.backOffice,
  user: state.auth.user,
  lng: state.params.lng,
  withoutHeader: state.auth.withoutHeader
});

export default connect(mapStateToProps)(SlideListPage);



// WEBPACK FOOTER //
// ./src/components/SlideList/SlideListPage.js